<script>
export default {
  props: {
    isLoading: { type: Boolean, default: false, },
    images: { type: Array, required: true, }
  },

  emits: [
    'update-active-index'
  ],

  methods: {
    emit(index) {
      this.$emit('update-active-index', index);
    },
  }
}
</script>

<template>
    <p
      v-if="!isLoading && images.length < 1"
    >
      Geen afbeeldingen aanwezig
    </p>
    <div
      class="image-list"
    >
      <template
        v-if="!isLoading"
      >
        <div
          v-for="image in images"
          :key="image"
          class="image center"
          :style="`background-image: url(${image})`"
          @click.prevent="emit(images.indexOf(image))"
        />
      </template>

      <template
        v-else
      >
        <div
          v-for="i in 8"
          :key="i" 
          class="image center placeholder"
        />
      </template>
    </div>
</template>

<style lang="scss" scoped>

.image-list {
  display: grid;
  grid-template-columns: repeat(5,1fr);
  grid-gap: 4px;
  width: 100%;

  .image {
    cursor: pointer;
    width: 100%;
    border-radius: 10px;
    height: 80px;
    background-size: cover;
    background-position: center;

    &.placeholder {
      height: 50px;
      width: 100%;
    }
  }
}
</style>